import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonalDetailComponent } from './Seva-Profile/personal-detail/personal-detail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbAccordionModule, NbActionsModule, NbCardModule, NbContextMenuModule, NbDatepickerModule, NbDialogModule,  NbIconModule,  NbLayoutModule, NbMenuModule, NbRadioModule, NbSidebarModule, NbStepperModule, NbToastrModule, NbTooltipModule, NbUserModule } from '@nebular/theme';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfirmApprovalModalComponent } from './Modalla-Popup/confirm-approval-modal/confirm-approval-modal.component';
import { ConfirmRejectionModalComponent } from './Modalla-Popup/confirm-rejection-modal/confirm-rejection-modal.component';
import { FormApprovalSuccessModalComponent } from './Modalla-Popup/form-approval-success-modal/form-approval-success-modal.component';
import { FormRejectionSuccessModalComponent } from './Modalla-Popup/form-rejection-success-modal/form-rejection-success-modal.component';
import { ApprovalStatusProgressbarComponent } from './Progress-Bar/approval-status-progressbar/approval-status-progressbar.component';
import { UserProfileMenuComponentComponent } from './Layout/user-profile-menu-component/user-profile-menu-component.component';
import { UserHeaderComponentComponent } from './Layout/user-header-component/user-header-component.component';
import { BarChartComponent } from './Charts/bar-chart/bar-chart.component';
import { PieChartComponent } from './Charts/pie-chart/pie-chart.component';
import { DoughnutChartComponent } from './Charts/doughnut-chart/doughnut-chart.component';
import { ImergencyContactDetailComponent } from './Seva-Profile/imergency-contact-detail/imergency-contact-detail.component';
import { CurrentAddressComponent } from './Seva-Profile/current-address/current-address.component';
import { StudyParticipationInformationComponent } from './Seva-Profile/study-participation-information/study-participation-information.component';
import { OtherPersonalInformationComponent } from './Seva-Profile/other-personal-information/other-personal-information.component';
import { MedicalHistoryComponent } from './Seva-Profile/medical-history/medical-history.component';
import { PhysicalAbilityComponent } from './Seva-Profile/physical-ability/physical-ability.component';
import { PhysicalFitnessComponent } from './Seva-Profile/physical-fitness/physical-fitness.component';
import { HealthInsuranceComponent } from './Seva-Profile/health-insurance/health-insurance.component';
import { LangaugeComponent } from './Seva-Profile/langauge/langauge.component';
import { HospitalAndAllergiesComponent } from './Seva-Profile/hospital-and-allergies/hospital-and-allergies.component';
import { ReferencesComponent } from './Seva-Profile/references/references.component';
import { UserLayoutComponent } from './Layout/user-layout/user-layout.component';
import { RouterModule } from '@angular/router';
import { ApprovalMatrixPreviewComponent } from './Layout/approval-matrix-preview/approval-matrix-preview.component';
import { AddReferenceComponent } from './COC/add-reference/add-reference.component';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { AccommodationDetailsComponent } from './Visiting-Seva/accommodation-details/accommodation-details.component';
import { SkillsComponent } from './Visiting-Seva/skills/skills.component';
import { ContemplationComponent } from './Visiting-Seva/contemplation/contemplation.component';
import { TentativeDateComponent } from './Visiting-Seva/tentative-date/tentative-date.component';
import { FamilyRetreatContemplationComponent } from './Contemplations/family-retreat-contemplation/family-retreat-contemplation.component';
import { PthContemplationComponent } from './Contemplations/pth-contemplation/pth-contemplation.component';
import { GurukulaSevaContemplationComponent } from './Contemplations/gurukula-seva-contemplation/gurukula-seva-contemplation.component';
import { HomeSevaContemplationComponent } from './Contemplations/home-seva-contemplation/home-seva-contemplation.component';
import { SyprContemplationComponent } from './Contemplations/sypr-contemplation/sypr-contemplation.component';
import { GurukulaSkillsComponent } from './Contemplations/gurukula-skills/gurukula-skills.component';
import { ConfirmationModalComponent } from './Modalla-Popup/confirmation-modal/confirmation-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PermissionModule } from 'src/Core/Permission Module/permission.module';
import { PreviewSevaProfileComponent } from './Seva-Profile/preview-seva-profile/preview-seva-profile.component';
import { PreviewVisitingSevaComponent } from './Visiting-Seva/preview-visiting-seva/preview-visiting-seva.component';
import { PreviewPthComponent } from './PTH/preview-pth/preview-pth.component';
import { FullScreenPopupComponent } from './Modalla-Popup/full-screen-popup/full-screen-popup.component';
import { ConfirmSendToFirstAidModalComponent } from './Modalla-Popup/confirm-send-to-first-aid-modal/confirm-send-to-first-aid-modal.component';
import { ApproveRectedActionComponent } from './Layout/approve-rected-action/approve-rected-action.component';
import { AllNotesListComponent } from './Layout/all-notes-list/all-notes-list.component';
import { AgGridModule } from 'ag-grid-angular';
import { AddNotesModalComponent } from './Modalla-Popup/add-notes-modal/add-notes-modal.component';
import { ResolvedByFirstAidModalComponent } from './Modalla-Popup/resolved-by-first-aid-modal/resolved-by-first-aid-modal.component';
import { ApplicationListGridComponent } from './application-list-grid/application-list-grid.component';
import { GenericDashboardComponent } from './generic-dashboard/generic-dashboard.component';
import { SevaProfileAggrementComponent } from './Modalla-Popup/seva-profile-aggrement/seva-profile-aggrement.component';
import { NotesAddedSucesfulModalComponent } from './Modalla-Popup/notes-added-sucesful-modal/notes-added-sucesful-modal.component';
import { CustomDatePickerComponent } from './custom-date-picker/custom-date-picker.component';
import { ClickOutsideDirective } from './custom-date-picker/click-outside.directive';
import { DatePickerDemoComponent } from './custom-date-picker/date-picker-demo.component';
import { CustomeYearPickerComponent } from './custom-date-picker/custome-year-picker/custome-year-picker.component';
import { CustomDateRangePickerComponent } from './custom-date-range-picker/custom-date-range-picker.component';
import { DateRangePickerDemoComponent } from './custom-date-range-picker/date-range-picker-demo.component';
import { CustomMonthYearPickerComponent } from './custom-month-year-picker/custom-month-year-picker.component';
import { DocumentComponent } from './Seva-Profile/document/document.component';
import { AddressSectionComponent } from './Seva-Profile/address-section/address-section.component';
import { PermantAddressComponent } from './Seva-Profile/permant-address/permant-address.component';
import { EducationalAndWorkexperienceComponent } from './Seva-Profile/educational-and-workexperience/educational-and-workexperience.component';
import { SummaryAndRequirementsModalComponent } from './Modalla-Popup/summary-and-requirements-modal/summary-and-requirements-modal.component';
import { CenterMappingComponent } from './Master-Mapping/center-mapping/center-mapping.component';
import { AppAocCocMappingModalComponent } from './Modalla-Popup/app-aoc-coc-mapping-modal/app-aoc-coc-mapping-modal.component';
import { AddendumDocumentUploadComponent } from './addendum-document-upload/addendum-document-upload.component';
import { RegistrationSuccessModalComponent } from './Modalla-Popup/registration-success-modal/registration-success-modal.component';
import { ConfirmSendBackToApplicantModalComponent } from './Modalla-Popup/confirm-send-back-to-applicant-modal/confirm-send-back-to-applicant-modal.component';
import { ConfirmForwardToGAOModalComponent } from './Modalla-Popup/confirm-forward-to-gao-modal/confirm-forward-to-gao-modal.component';
import { AuditHistoryGridComponent } from './audit-history-grid/audit-history-grid.component';
import { ChangeStateModalComponent } from './Modalla-Popup/change-state-modal/change-state-modal.component';




@NgModule({
  declarations: [
    PersonalDetailComponent,
    ConfirmApprovalModalComponent,
    ConfirmRejectionModalComponent,
    FormApprovalSuccessModalComponent,
    FormRejectionSuccessModalComponent,
    RegistrationSuccessModalComponent,
    ApprovalStatusProgressbarComponent,
    UserProfileMenuComponentComponent,
    UserHeaderComponentComponent,
    BarChartComponent,
    PieChartComponent,
    DoughnutChartComponent,
    ImergencyContactDetailComponent,
    CurrentAddressComponent,
    StudyParticipationInformationComponent,
    OtherPersonalInformationComponent,
    MedicalHistoryComponent,
    PhysicalAbilityComponent,
    PhysicalFitnessComponent,
    PhysicalFitnessComponent,
    HealthInsuranceComponent,
    LangaugeComponent,
    HospitalAndAllergiesComponent,
    ReferencesComponent,
    UserLayoutComponent,
    ApprovalMatrixPreviewComponent,
    AddReferenceComponent,
    AccommodationDetailsComponent,



    SkillsComponent,
    ContemplationComponent,
    TentativeDateComponent,
    PthContemplationComponent,
    FamilyRetreatContemplationComponent,
    GurukulaSevaContemplationComponent,
    HomeSevaContemplationComponent,
    SyprContemplationComponent,
    GurukulaSkillsComponent,
    ConfirmationModalComponent,
    PreviewSevaProfileComponent,
    PreviewVisitingSevaComponent,
    PreviewPthComponent,
    FullScreenPopupComponent,
    ConfirmSendToFirstAidModalComponent,
    ApproveRectedActionComponent,
    AllNotesListComponent,
    AddNotesModalComponent,
    ResolvedByFirstAidModalComponent,
    ApplicationListGridComponent,
    GenericDashboardComponent,
    SevaProfileAggrementComponent,
    NotesAddedSucesfulModalComponent,
    CustomDatePickerComponent,
    ClickOutsideDirective,
    DatePickerDemoComponent,
    CustomeYearPickerComponent,
    CustomDateRangePickerComponent,
    DateRangePickerDemoComponent,
    CustomMonthYearPickerComponent,
    DocumentComponent,
    AddressSectionComponent,
    PermantAddressComponent,
    EducationalAndWorkexperienceComponent,
    SummaryAndRequirementsModalComponent,
    CenterMappingComponent,
    AppAocCocMappingModalComponent,
    AddendumDocumentUploadComponent,
    ConfirmSendBackToApplicantModalComponent,
    ConfirmForwardToGAOModalComponent,
    AuditHistoryGridComponent,
    ChangeStateModalComponent

  ],
  imports: [
    CommonModule,
    NbActionsModule,
    NgSelectModule,
    NbRadioModule, 
    NbUserModule,  
    NbMenuModule,
    NbContextMenuModule,
    RouterModule, 
    NbStepperModule,          
    NbAccordionModule,
    NbLayoutModule,
    NbSidebarModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    NbTooltipModule,
    NbToastrModule,
    NbEvaIconsModule,
    NbDatepickerModule,
    NbCardModule,
    NbIconModule,  // Add this line
    NbDialogModule.forChild(),
    PermissionModule,
    AgGridModule,
    NbMenuModule, // <-- Make sure NbMenuModule is imported here
   
    
  ],
  exports: [
    PersonalDetailComponent,
    ConfirmApprovalModalComponent,
    ConfirmRejectionModalComponent,
    FormApprovalSuccessModalComponent,
    FormRejectionSuccessModalComponent,
    RegistrationSuccessModalComponent,
    ApprovalStatusProgressbarComponent,
    UserProfileMenuComponentComponent,
    UserHeaderComponentComponent,
    BarChartComponent,
    PieChartComponent,
    DoughnutChartComponent,
    ImergencyContactDetailComponent,
    CurrentAddressComponent,
    StudyParticipationInformationComponent,
    OtherPersonalInformationComponent,
    MedicalHistoryComponent,
    PhysicalAbilityComponent,
    PhysicalFitnessComponent,
    HealthInsuranceComponent,
    LangaugeComponent,
    HospitalAndAllergiesComponent,
    ReferencesComponent,
    UserLayoutComponent,
    ApprovalMatrixPreviewComponent,
    AddReferenceComponent,
    AccommodationDetailsComponent,
    SkillsComponent,
    ContemplationComponent,
    TentativeDateComponent,
    PthContemplationComponent,
    FamilyRetreatContemplationComponent,
    GurukulaSevaContemplationComponent,
    HomeSevaContemplationComponent,
    SyprContemplationComponent,
    GurukulaSkillsComponent,
    ConfirmationModalComponent,
    PreviewSevaProfileComponent,
    PreviewVisitingSevaComponent,
    PreviewPthComponent,
    FullScreenPopupComponent,
    ConfirmSendToFirstAidModalComponent,
    ApproveRectedActionComponent,
    AllNotesListComponent,
    AddNotesModalComponent,
    ResolvedByFirstAidModalComponent,
    ApplicationListGridComponent,
    GenericDashboardComponent,
    SevaProfileAggrementComponent,
    NotesAddedSucesfulModalComponent,
    CustomDatePickerComponent,
    ClickOutsideDirective,
    DatePickerDemoComponent,
    CustomeYearPickerComponent,
    CustomDateRangePickerComponent,
    DateRangePickerDemoComponent,
    CustomMonthYearPickerComponent,
    DocumentComponent,
    AddressSectionComponent,
    PermantAddressComponent,
    EducationalAndWorkexperienceComponent,
    SummaryAndRequirementsModalComponent,
    CenterMappingComponent,
    AppAocCocMappingModalComponent,
    PermissionModule,
    AddendumDocumentUploadComponent,
    AuditHistoryGridComponent
  ]
})
export class SharedModule { }
